import { useContext } from "react";
import { serviceUrl } from "src/utils/formatUrl";

import Context from "../context";

export const useGetLink = () => {
	const { state } = useContext(Context);

	return {
		link: serviceUrl(
			state.type,
			state.redirectSelected?.id ?? "",
			state.themeMode,
			state.languageSelected?.value ?? "es_ES",
			state.type === "transfers" ? state.positionType : undefined
		)
	};
};
